<template>
  <layout-main-inner title="批次详情">
    <template slot="action">
      <el-button
        v-if="(batchInfo.status !== 9 && userPermission.ENT && batchInfo.status !== 3) && (batchInfo.outGoodsCount === null || batchInfo.outGoodsCount === 0)"
        type="primary"
        :loading="loading"
        @click="edit">编辑</el-button>
      <el-button
        v-if="userPermission.OPERATE && (batchInfo.status === 9 || batchInfo.status === 3)"
        type="primary"
        :loading="loading"
        @click="edit">编辑</el-button>
    </template>
    <template slot="append">
      <span
        v-if="userPermission.SUPERVISE || userPermission.OPERATE"
        style="color:#888">({{ batchInfo.vendorName }})</span>
      <el-tag
        v-if="batchInfo.status === 9"
        type="danger">紧急召回({{ batchInfo.statusDesc }})</el-tag>
      <el-tag
        v-if="batchInfo.status === 3"
        type="success">检验通过</el-tag>
    </template>
    <product-info
      :loading="loading"
      :batchInfo="batchInfo"
      :product="product" />

    <batch-form-dz
      v-if="product.tagType === 1"
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 1 "
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm-no-tag
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 9 "
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-pm-ck
      v-if="product.tagType !== 1 && batchInfo.tagModel === 1 && product.codingType === 2 "
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-tm
      v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 1 "
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :tradeType="product.tradeType"
      :tag="tagInfo"
      :productId="product.productId"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <batch-form-tm-ck
      v-if="product.tagType !== 1 && batchInfo.tagModel === 2 && product.codingType === 2 "
      ref="form"
      :isDetail="true"
      :loading="loading"
      :batch="batchInfo"
      :productId="product.productId"
      :tradeType="product.tradeType"
      :tagType="product.tagType"
      :vendorId="+$route.query.vendorId" />

    <layout-card-wrap
      v-if="total> 0"
      v-loading="loading"
      hasHeaderSlot
      style="margin-top:8px">
      <template slot="title">标签信息</template>
      <el-table
        v-loading="loading"
        border
        :data="labels">
        <el-table-column
          label="箱码序号"
          prop="formatedTagNo"></el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="{ row }">
            <el-popover
              placement="top-start"
              width="400"
              trigger="hover">
              <el-table
                border=""
                :data="row.tagCodes">
                <el-table-column
                  width="100"
                  prop="formatedTagNo"
                  label="标签序号"></el-table-column>
                <el-table-column
                  property="tagCode"
                  label="标签码"></el-table-column>
              </el-table>
              <el-button
                slot="reference"
                type="warning">查看标签码 </el-button>
            </el-popover>

            <!-- <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="viewItem(row)">查看标签码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <template slot="footer">
      <!-- <back-button ref="back" /> -->

    </template>
  </layout-main-inner>
</template>
<script>
import ProductInfo from './busi/product-info.vue'
import batchFormDz from './busi/batch-form-dz.vue'
import batchFormPm from './busi/batch-form-pm.vue'
import batchFormPmNoTag from './busi/batch-form-pm-no-tag.vue'
import batchFormTm from './busi/batch-form-tm.vue'
import batchFormPmCk from './busi/batch-form-pm-ck.vue'
import batchFormTmCk from './busi/batch-form-tm-ck.vue'
import TemplateFormat from '@/utils/templateFormat'
import { mapState } from 'vuex'
export default {
  name: 'BatchDetail',
  components: { ProductInfo, batchFormDz, batchFormPm, batchFormPmNoTag, batchFormTm, batchFormPmCk, batchFormTmCk },
  props: {},
  data() {
    return {
      loading: false,
      batchInfo: {},
      product: {},
      tagInfo: {},
      config: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      labels: []
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  mounted() {
    this.getBatch({
      vendorId: this.$route.query.vendorId,
      batchId: this.$route.query.batchId
    })
    this.getlabel()
    this.getproduct({
      vendorId: this.$route.query.vendorId,
      productId: this.$route.query.productId
    })
  },
  methods: {
    getBatch(config, cb) {
      this.loading = true
      this.$store.dispatch('batch/getbatch', {
        payload: config,
        success: (res) => {
          this.loading = false
          res.data.baseFields = TemplateFormat.editTemplateFormat(res.data.baseFields)
          res.data.extraFields = TemplateFormat.editTemplateFormat(res.data.extraFields || [])
          this.batchInfo = res.data
          if (res.data.tagModel === 2 && res.data.codingType === 1) {
            this.tagInfo = {
              tagCount: res.data.tagCount,
              beginTagNo: res.data.beginTagNo,
              endTagNo: res.data.endTagNo
            }
          }
          cb && cb(res.data.productId)
        },
        fail: () => {
          this.loading = false
          this.batchInfo = {}
        }
      })
    },
    getproduct(config) {
      this.loading = true
      this.$store.dispatch('product/getproduct', {
        payload: config,
        success: (res) => {
          this.loading = false
          this.product = res.data
        },
        fail: () => {
          this.loading = false
          this.product = {}
        }
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.getlabel()
    },
    getlabel() {
      this.loading = true
      this.$store.dispatch('batch/getbatchtags', {
        payload: this.$route.query,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.labels = res.data.records
        },
        fail: () => {
          this.loading = false
          this.labels = []
        }
      })
    },
    edit() {
      this.$router.push(`/batch-update?vendorId=${this.$route.query.vendorId}&batchId=${this.$route.query.batchId}&productId=${this.$route.query.productId}`)
    },
    viewItem(row) {
      console.log(row.tagCodes)
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to, from, next)
    if (to.fullPath !== from.fullPath) {
      next()
      this.getBatch({
        vendorId: this.$route.query.vendorId,
        batchId: this.$route.query.batchId
      })
      this.getlabel()
      this.getproduct({
        vendorId: this.$route.query.vendorId,
        productId: this.$route.query.productId
      })
    }
  }
}
</script>
